<Teleport to="body">
  <Transition name="base-modal-backdrop">
    <div
      v-if="isOpen"
      class="base-modal-backdrop"
      :class="[panelClass, $attrs.class]"
      role="dialog"
      aria-modal="true"
      @click.self="onBackdropClick"
    >
      <div class="base-modal-panel" :style="panelStyle" ref="modalPanel" tabindex="-1" @keydown="handleTab">
        <header v-if="$slots.header" class="base-modal-header">
          <div class="base-modal-header__content" :class="showCloseButton ? 'with-close-button' : ''">
            <slot name="header" />
          </div>
          <button
            v-if="showCloseButton"
            type="button"
            class="base-modal-header__close"
            aria-label="Close"
            @click="close"
          >
            <span class="base-modal-header__close-icon iconfont-cross" aria-hidden="true" />
          </button>
        </header>
        <div class="base-modal-body">
          <slot name="content">
            <slot />
          </slot>
        </div>
        <footer v-if="$slots.footer" class="base-modal-footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </Transition>
</Teleport>
